import { Web3AuthContext } from '@context/web3auth-context';
import { useContext } from 'react';

const useWeb3Auth = (): Web3AuthContext => {
  return useContext(Web3AuthContext);
};

export default useWeb3Auth;
